import type { FC, ReactNode } from 'react'

import type { WhiteLabel } from '@skytech/types'
import { twJoin } from 'tailwind-merge'

export const Label: FC<{
  htmlFor?: string
  className?: string
  capitalizeLabel?: boolean
  noMargin?: boolean
  whiteLabel?: WhiteLabel
  children: ReactNode
}> = ({
  className = '',
  capitalizeLabel,
  children,
  noMargin,
  whiteLabel: _whiteLabel,
  ...restOfProps
}) => {
  // todo: replace with the org from url when ready
  const storedWhiteLabel = localStorage.getItem('org') as WhiteLabel
  const whiteLabel = _whiteLabel || storedWhiteLabel || 'control'

  return (
    <label
      className={twJoin(
        'ui-label',
        'block text-sm md:text-base md:leading-5',
        noMargin ? 'm-0' : 'mb-2',
        capitalizeLabel && 'capitalize',
        whiteLabelText[whiteLabel] || whiteLabelText.skytech,
        className
      )}
      {...restOfProps}
    >
      {children}
    </label>
  )
}

const whiteLabelText: Partial<Record<WhiteLabel, string>> = {
  skytech: 'text-gray',
  control: 'text-gray',
  telia: 'text-telia-grayText font-telia',
  threeStepIT: 'text-threeStepIT-codex font-threeStepIT',
}
